scrollToTaskIdRun.$inject = ['$rootScope', '$timeout', 'TasksFactory', 'ScrollFactory'];
export function scrollToTaskIdRun($rootScope, $timeout, TasksFactory, ScrollFactory) {

  $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams, options) {

    // restore scroll position when switching from process view to task list view
    if (fromState.name.endsWith('tasks.process') && toState.name.endsWith('tasks')) {
      $timeout(function () {
        // First of all, we wait 50ms for DOM rendering of the tasks list
        let taskInListElement = document.getElementById(fromParams.processedTaskId.toString());
        if (taskInListElement !== null) {
          // Depending on the browser and possibly other causes,
          // the task filters at the top of the page will or will not have rendered when we execute this code.
          // Hence we must compute an offset delta relative to the .task-list parent div, rather than use the absolute offset.
          // Plese note that the code below depends on the DOM structure in tasks.list.inbox/pending.html (and tasksList.html),
          // which is not ideal, but at least there is a comment in those files to update down here too if the markup is modified there.
          // Please note also that the following code would be more consise using .position() on the rowELement,
          // but I leave it with a substraction of 2 offsets so that it remains clear how to update the code here
          // in case of DOM tree modifications in tasks.list.html
          const rowELement = taskInListElement.parentElement.parentElement;
          const tasksListElement = rowELement.parentElement;
          const filtersHeight = toState.name.includes('search') ? 570 : 70;
          let scrollPosition = angular.element(rowELement).offset().top - angular.element(tasksListElement).offset().top + filtersHeight;
          ScrollFactory.scrollMainContainerTo(scrollPosition, 500);
        }
      }, 50);
      TasksFactory.focusDummyButton('in-tasks-list', 700);
    }
  });  

}